export default "__VITE_ASSET__641b6f8b__"